import styled from '@emotion/styled';
import { ButtonStyled } from '@nike/nike-design-system-components';
import { useStadium } from 'stadium/StadiumHooks';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ButtonWrapper = styled.div(function () {
  return {
    display: 'flex',
    gap: '15px',
    marginTop: '10px',
    justifyContent: 'flex-end'
  };
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var NotificationFooterButtons = function NotificationFooterButtons(props) {
  var closeModal = props.closeModal,
    xfPath = props.xfPath,
    _props$root = props.root,
    ok = _props$root.ok,
    leftButtonText = _props$root.leftButtonText,
    leftButtonLink = _props$root.leftButtonLink,
    leftButtonTabCheck = _props$root.leftButtonTabCheck;
  var _useStadium = useStadium(),
    sendInteractionEvent = _useStadium.analyticsHooks.sendInteractionEvent;
  var isShowLeftButton = leftButtonText && leftButtonLink;
  return /*#__PURE__*/_jsxs(ButtonWrapper, {
    children: [isShowLeftButton && /*#__PURE__*/_jsx(ButtonStyled, {
      onClick: function onClick() {
        sendInteractionEvent("homepage:notification:".concat(xfPath, ":").concat(leftButtonText, ":").concat(leftButtonLink));
        return false;
      },
      appearance: "primary",
      background: "light",
      type: "button",
      Component: "a",
      target: leftButtonTabCheck === 'true' ? '_blank' : '_self',
      href: leftButtonLink,
      "data-testid": "left-button",
      placeholder: undefined,
      onPointerEnterCapture: undefined,
      onPointerLeaveCapture: undefined,
      children: leftButtonText
    }), /*#__PURE__*/_jsx(ButtonStyled, {
      appearance: "primary",
      background: "light",
      type: "button",
      onClick: function onClick() {
        sendInteractionEvent("homepage:notification:".concat(xfPath, ":").concat(ok || 'Ok', ":closemodal"));
        closeModal();
        return false;
      },
      placeholder: undefined,
      onPointerEnterCapture: undefined,
      onPointerLeaveCapture: undefined,
      children: ok || 'Ok'
    })]
  });
};
export default NotificationFooterButtons;